module.exports = __webpack_public_path__ + "img/36_83.d040ceda.png";